<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2 scrollTableNoTab finance-budget">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @clone-master="cloneData"
                            @new-item="openCreateModal"
                            @delete-items="deleteItems"
                            @row-click="openCreateModal"
                            @export="exportItems"
                            @change-selected="getIdSelected"
                            @get-column-settings="getColumnSettings"
                            ref="gofixTable">
                            <template slot="gofix_table:financial_year_start" slot-scope="row">
                                {{ row.item.financial_year_start | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}
                            </template>
                            <template slot="gofix_table:financial_year_end" slot-scope="row">
                                {{ row.item.financial_year_end | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}
                            </template>
                            <template slot="gofix_table:total_budget_revenue" slot-scope="row">
                                {{ row.item.total_budget_revenue | formatMoney }}
                            </template>
                            <template slot="gofix_table:total_budget_expenses" slot-scope="row">
                                {{ row.item.total_budget_expenses | formatMoney }}
                            </template>
                            <template slot="gofix_table:status" slot-scope="row">
                                <span class="opacity-05">{{ row.item.status }}</span>
                            </template>
                            <template slot="gofix_table:tracking" slot-scope="row">
                                <gofix-button v-if="row.item.status == 'Approved'" class="mr-4" label="Budget Tracking" @click="goToTracking(row.item)" outline></gofix-button>
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>
        <ModalAddBudget 
            :title="modals.title" 
            :isCloneBudget="modals.isClone"
            :dataClone="modals.clone"
            v-model="modals.open"
            @saveSuccess="reloadItems"/>
    </div>
</template>
<script>

    import { filters } from '@/_filterVar.js';
    const ModalAddBudget = () => import('./modal-add-budget.vue')

    export default {
        name: 'budget-list-header',
        components: {
            ModalAddBudget
        },
        data() {
            let filter = JSON.parse(JSON.stringify(filters['budget_headers']));
            return {
                
                columnSettings: [],
                tableConfig:{
                    name: 'finance-budget-allocation',
                    controls:{
                        tableImport: false,
                        tableCloneMaster: true,
                        tableCloneMasterIcon: 'img/copy.png'
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    fields: []
                },
                tableItems: [],
                modals:{
                    open: false,
                    title: 'New Budget',
                    isClone: false,
                    clone: {
                        ids: [],
                        client_contract_id: null,
                        department_code: null
                    }
                },
            }
        },
        methods: {
            getIdSelected(ids) {
                this.modals.clone.ids = ids;
            },
            getColumnSettings(settings){
                this.columnSettings = settings;
                if(this.$refs.gofixTable)
                    this.updateColumnSettings();
            },
            updateColumnSettings() {
                let columnAutoWith = null;
                if(this.columnSettings[this.columnSettings.length - 1] && this.columnSettings[this.columnSettings.length - 1].key == "autowidth") {
                    columnAutoWith = this.columnSettings[this.columnSettings.length - 1];
                    this.columnSettings.pop();
                }
                this.columnSettings.push({
                    key: 'tracking',
                    label: '',
                    isActive: 1,
                    thStyle: "width:170px",
                    isFilter: false,
                    sorting: false
                });

                if(columnAutoWith)
                    this.columnSettings.push(columnAutoWith);

                this.$refs.gofixTable.updateColumnSettings(this.columnSettings);
            },
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                this.updateColumnSettings();
                await this.$store.dispatch("BudgetAllocationController/getHeaderItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load the items", "danger");
                        reject();
                    })
            },
            async deleteItems(callback){
                const { ids, filter, resolve,reject } = await callback();
                let arrTmp = this.tableItems.filter(item => ids.includes(item.id) && item.status == 'Approved');
                if(arrTmp.length) {
                    this.$alertNotification("You cannot delete records with the status Approved", "danger");
                    resolve('');
                    return
                }
                this.$store.dispatch("BudgetAllocationController/deleteHeaderItem", ids)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(err =>{
                        reject(err);
                    });
            },
            reloadItems() {
                this.$refs.gofixTable.reloadTableItems();
            },
            cloneData() {
                if(!this.modals.clone.ids.length) {
                    return this.$alertNotification("Please select 1 line before clone new budget", "danger");
                }

                if(this.modals.clone.ids.length > 1) {
                    return this.$alertNotification("You can only select 1 line to clone new budget", "danger");
                }

                let tmp = this.tableItems.filter(item => this.modals.clone.ids.includes(item.id));
                if(tmp.length) {
                    this.modals.clone.client_contract_id = tmp[0].client_contract_id;
                    this.modals.clone.department_code = {
                        id: tmp[0].finance_linking_id,
                        property_id: tmp[0].property_id,
                        dept_code: tmp[0].dept_code,
                    };
                }

                this.modals.title   = 'Clone New Budget';
                this.modals.isClone = true;
                this.modals.open    = true;
            },
            openCreateModal(item){
                if(!item) {
                    this.modals.title   = 'New Budget';
                    this.modals.isClone = false;
                    this.modals.open    = true;
                } else {
                    this.$router.push(`/v2/budget/${item.id}`)
                }                
            },
            goToTracking(item) {
                this.$router.push(`/v2/budget/${item.id}/budget-tracking`)
            },
            exportItems(tableRequest) {
                let request = JSON.parse(JSON.stringify(this.$refs.gofixTable.tableRequest));
                this.$store.dispatch('BudgetAllocationController/exportBudgetHeader', request)
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Budget.csv'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                })
            },
        }
    }
</script>
